import React from "react";
import PremiumSearch from "./PremiumSearch";

type Props = {
  selectOptions?: any;
  name?: string;
  opt?: string;
  className?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

export default function NormalSearch(props: Props) {
  return (
    <PremiumSearch
      name={props.name}
      className={props.className}
      value={props.value}
      onChange={props.onChange}
    />
  );
}
